import { SigmaNodeEventPayload } from "sigma/sigma";
import { NodeMenuSetter } from "../types/menu";

/**
 * Shared right-click handler for Sigma nodes to open the node context menu.
 */
export const createRightClickNodeHandler = (setNodeMenuState: NodeMenuSetter) =>
  ({ node, event }: SigmaNodeEventPayload) => {
    event.preventSigmaDefault();
    event.original?.preventDefault?.();
    const mouseX = (event.original as MouseEvent | undefined)?.clientX ?? event.x;
    const mouseY = (event.original as MouseEvent | undefined)?.clientY ?? event.y;

    setNodeMenuState({
      nodeId: node,
      anchor: { mouseX, mouseY },
    });
  };
